import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getApiUrl, getBackendUrl, getPublicUrl } from '../utils/common';



// Create axios instance with custom config
const api = axios.create({
    baseURL: getApiUrl(),
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        // 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, PATCH, OPTIONS',
        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Authorization',
    },
    withCredentials: true,
});

// Function to get CSRF token
// const getCsrfToken = async () => {
//     try {
//         await axios.get(`${getBackendUrl()}/sanctum/csrf-cookie`, { withCredentials: true });
//     } catch (error) {
//         console.error('Error fetching CSRF token:', error);
//     }
// };

// Add a request interceptor
api.interceptors.request.use(
    async (config) => {
        // Get token from localStorage
        const token = localStorage.getItem('auth_token');
        
        // If token exists, add it to request headers
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            config.headers['X-Authorization'] = `Bearer ${token}`;
        }

        // For mutation requests (POST, PUT, PATCH, DELETE), get CSRF token first
        // if (['post', 'put', 'patch', 'delete'].includes(config.method?.toLowerCase())) {
        //     await getCsrfToken();
        //     const csrf_token = getCookie('XSRF-TOKEN');
        //     if(csrf_token){
        //         config.headers['X-XSRF-TOKEN'] = csrf_token;
        //     }
        // }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        // Handle 401 Unauthorized errors
        if (error.response?.status === 401) {
            // Clear localStorage and redirect to login
            localStorage.clear();
            const navigate = useNavigate();
            navigate('/login');
            // window.location.href = getPublicUrl()+'/login';
        }
        return Promise.reject(error);
    }
);

export default api;